module.exports = __webpack_public_path__ + "img/ibimage12.73b3e844.jpg";